import type { CustomValue, ProductOption } from '@99designs/graph-utils/types';

export type AvailableOptionsType = ProductOption | CustomValue;

export type ProductOptionReviewType = {
    key: string;
    name: string;
    value: { name: string; imageUrl: string | undefined; unit: string | undefined };
};

export function isProductOptionType(option: AvailableOptionsType): option is ProductOption {
    return (option as ProductOption).values !== undefined;
}
